function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   background-color: ", ";\n   box-shadow: -1px 9px 27px 0 hsla(222, 16%, 22%, 0.07);\n   overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
var Card = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.brandColors.white;
});
export { Card };